import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { Card as BootstrapCard } from 'reactstrap';

interface PropTypes {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  ignorePadding?: boolean;
}

export function Card(props: PropTypes) {
  const padding = props.ignorePadding ? 'p-0' : 'p-4';

  return (
    <BootstrapCard
      className={classNames('rounded-4 shadow-sm', props.className, padding)}
      style={props.style}
    >
      {props.children}
    </BootstrapCard>
  );
}

export function CardTitle(props: { children: ReactNode }) {
  return <div className='fs-3 fw-semibold'>{props.children}</div>;
}
